module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('h1', {
    staticClass: "chapter"
  }, [_c('em', [_vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/list.htm"
    }
  }, [_c('em', [_vm._v("List of Figures")])])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/int.htm"
    }
  }, [_c('em', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c01.htm"
    }
  }, [_vm._v("I\tDo Spells Work?")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c02.htm"
    }
  }, [_vm._v("II\tWhy and How")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c03.htm"
    }
  }, [_vm._v("III\tThe Ethics of Spell-Working")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c04.htm"
    }
  }, [_vm._v("IV\tThe Boomerang Effect")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c05.htm"
    }
  }, [_vm._v("V\tPsychic Self-Defence")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c06.htm"
    }
  }, [_vm._v("VI\tSetting About It")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c07.htm"
    }
  }, [_vm._v("VII\tSex Magic")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c08.htm"
    }
  }, [_vm._v("VIII\tSpell-Working and the Cabala")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c09.htm"
    }
  }, [_vm._v("IX\tTalismans")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c10.htm"
    }
  }, [_vm._v("X\tComing Unstuck")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c11.htm"
    }
  }, [_vm._v("XI\tSpells of the Ancient World")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c12.htm"
    }
  }, [_vm._v("XII\tSpells of the Middle Ages and Later")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c13.htm"
    }
  }, [_vm._v("XIII\tSpells from Other Lands")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c14.htm"
    }
  }, [_vm._v("XIV\tSpells of the People")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c15.htm"
    }
  }, [_vm._v("XV\tHealing Spells")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c16.htm"
    }
  }, [_vm._v("XVI\tLove Spells")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c17.htm"
    }
  }, [_vm._v("XVII\tSpells to Solve Problems")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c18.htm"
    }
  }, [_vm._v("XVIII\tWeather Spells")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c19.htm"
    }
  }, [_vm._v("XIX\tBinding Spells")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c20.htm"
    }
  }, [_vm._v("XX\tOdd Ones Out")])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/c21.htm"
    }
  }, [_vm._v("XXI\tTailpiece")])]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ap1.htm"
    }
  }, [_c('em', [_vm._v("Appendix 1: Planetary Hours")])])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ap2.htm"
    }
  }, [_c('em', [_vm._v("Appendix 2: Planetary Squares")])])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ap3.htm"
    }
  }, [_c('em', [_vm._v("Appendix 3: Magical Alphabets")])])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/ap4.htm"
    }
  }, [_c('em', [_vm._v("Appendix 4: Some Suppliers")])])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/glo.htm"
    }
  }, [_c('em', [_vm._v("Glossary")])])]), _vm._v(" "), _c('p', {
    staticClass: "para3"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/bib.htm"
    }
  }, [_c('em', [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33ef1ee3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/toc.vue
// module id = 60
// module chunks = 0